<template>
  <div id="register" class="container">
    <div class="jacket">
      <div class="pTitle">新用户注册</div>
      <div class="form">
        <div style="margin-bottom:30px;width:100%;">
          <el-steps :space="200" :active="setp" align-center>
            <el-step title="填写手机号"></el-step>
            <el-step title="填写密码"></el-step>
            <el-step title="注册完成"></el-step>
          </el-steps>
        </div>
        <!-- <aiticleStemp :dataList="dataList"></aiticleStemp> -->
        <div style="padding-top:30px;" v-if="setp==0">
          <el-alert
            :title="error"
            type="error"
            effect="dark"
            style="margin-bottom:20px"
            v-if="error.length>0"
            show-icon
            @close="close"
          ></el-alert>
          <el-form label-position="right" label-width="100px">
            <el-form-item label="手机号：">
              <el-input v-model="form1.mobile" placeholder="请输入正确的手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码：">
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-input v-model="form1.imgCode" placeholder="图片验证码"></el-input>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div @click="initData()" style="padding-left:10px;cursor: pointer;">
                    <img :src="src" />
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="短信验证码：">
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-input v-model="form1.msgCode" placeholder="短信验证码"></el-input>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div style="padding-left:10px">
                    <el-button
                      type="primary"
                      plain
                      @click="getMessageCode"
                      :disabled="msgDisable"
                    >{{text1}}</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
          <div align="center" style="margin-top:50px">
            <!-- <button class="next-step">下一步</button> -->
            <el-button class="next-step" type="primary" @click="tpSetp2">下一步</el-button>
          </div>
        </div>
        <div style="padding-top:20px;" v-if="setp==1">
          <el-alert
            :title="error"
            type="error"
            effect="dark"
            show-icon
            @close="close"
            style="margin-bottom:20px"
            v-if="error.length>0"
          ></el-alert>
          <el-form label-position="right" label-width="140px">
            <el-form-item label="密码：">
              <el-input
                type="password"
                v-model="form2.pw1"
                placeholder="请输入6-20位密码"
                style="float:left"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码：">
              <el-input type="password" show-password placeholder="确认密码" v-model="form2.pw2"></el-input>
            </el-form-item>
          </el-form>
          <div align="center">
            <el-checkbox v-model="read" style="font-size:12px;">
              已阅读并同意
              <router-link to="/agreement" target="_blank">
                <span style="color:#e2211c">《用户服务协议》</span>
              </router-link>
            </el-checkbox>
          </div>
          <div align="center" style="margin-top:50px">
            <el-button
              class="next-step"
              type="primary"
              @click="createuser"
              :disabled="!(read&&(form2.pw1==form2.pw2))"
            >下一步</el-button>
          </div>
        </div>
        <div style="padding-top:30px;" v-if="setp==3" class="finish">
          <i class="far fa-check-circle" style="margin-right:10px"></i>
          <span class="lv2Text">注册成功,</span>
          <router-link to="/login" style="margin-left:5px">
            <el-link type="primary">立即登录</el-link>
          </router-link>

          <span class="lv2Text" style="margin-left:5px">,</span>
          <el-link @click="register1()" type="primary">继续注册</el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bioInput from "../../components/bioInput.vue";
import aiticleStemp from "../../components/article_stemp.vue";
let Base64 = require("js-base64").Base64;
export default {
  components: { bioInput, aiticleStemp },
  data() {
    return {
      //
      serve: this.$store.state.serve,

      form1: {},
      form2: {
        p_user: "",
        c_user: ""
      },
      setp: 0,
      src: "",
      text1: "获取短信",
      msgDisable: false,
      read: false,
      p_user: "",
      c_user: "",
      error: "",
      dataList: ["填写手机号", "填写密码", "注册成功"]
    };
  },
  methods: {
    register1() {
      window.location.reload();
    },
    close() {
      this.error = "";
    },
    createuser() {
      let user_from = "";
      user_from = this.$cookies.get("user_from");
      this.axios
        .get(this.serve + "/register", {
          params: {
            bind_mobile: this.form1.mobile,
            password: this.form2.pw1,
            new_pass: this.form2.pw2,
            code: this.form1.msgCode,
            p_user: this.form2.p_user,
            c_user: this.form2.c_user,
            user_from
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$cookies.remove("user_from");
            this.setp = 3;
          } else if (res.data.status == "error") {
            if (res.data.msg == "未知错误") {
              this.error = "操作失败";
            } else {
              this.error = res.data.msg;
            }
          }
        });
    },
    tpSetp2() {
      this.axios
        .get(this.serve + "/register_code_compare", {
          params: {
            send_mobile: this.form1.mobile,
            code: this.form1.msgCode
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.setp = 1;
          } else if (res.data.status == "error") {
            if (res.data.msg == "未知错误") {
              this.error = "操作失败";
            } else {
              this.error = res.data.msg;
            }
          }
        });
    },
    getMessageCode() {
      if (this.form1.imgCode) {
        this.axios
          .get(this.serve + "/send_register_note", {
            params: {
              send_mobile: this.form1.mobile,
              code: this.form1.imgCode
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$message({
                showClose: true,
                message: "短息已发送",
                offset: 400,
                type: "success"
              });
              this.text1 = "60s后重新发送";
              this.msgDisable = true;
              var t = 60;
              var that = this;
              var t1 = setInterval(function() {
                t--;
                if (t == 0) {
                  clearInterval(t1);
                  that.msgDisable = false;
                  that.text1 = "获取短信";
                } else {
                  that.text1 = t + "s后重新发送";
                }
              }, 1000);

              if (res.data.status == "success") {
              }
            } else {
              this.error = res.data.msg;
            }
          });
      } else {
        this.error = "未填写验证码";
      }
    },
    initData() {
      if (this.$route.query.c_user) {
        this.form2.c_user = Base64.decode(this.$route.query.c_user);
      }
      this.axios.get(this.serve + "/verify_code").then(res => {
        this.src = "data:image/jpeg;base64," + res.data;
      });
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    // var pattern = /^([a-zA-Z]|[0-9])\S{5,19}$/;//匹配一个字母或数字开头6-20位的密码可选字符
    // console.log(pattern.test('p11231111111111111=='));
  }
};
</script>
<style lang="scss">
#register {
  .next-step {
    width: 318px;
    height: 48px;
  }
  .u {
    color: #e2211c;
    position: relative;
    left: 20px;
  }
  .finish {
    font-size: 30px;
    color: #e2211c;
    text-align: center;
  }
  .el-step__head.is-success {
    border-color: #e2211c;
    color: #fff;
  }
  .is-success .el-step__icon {
    background-color: #e2211c;
  }

  padding: 20px 0 40px 0;
  .jacket {
    background-color: #fff;
    padding: 30px 40px 60px 40px;
    display: block;
    border: 1px solid #dddddd;
  }
  .pTitle {
    margin-bottom: 40px;
  }
  .form {
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-checkbox__inner:hover,
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #e2211c;
    }
    width: 380px;
    margin: 0 auto;
    .title {
      color: #e2211c;
      text-align: center;
      margin-bottom: 20px;
      font-size: 17px;
    }
    .btn-code {
      display: block;
      height: 40px;
      background-color: #fff;
      border: 1px solid #e2211c;
      color: #e2211c;
      border-radius: 5px;
      padding: 0 15px;
      cursor: pointer;
    }
    .register-btn {
      background-color: #e2211c;
      width: 100%;
      font-size: 16px;
      padding: 15px 0;
      border: 0;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>